/**
 * The avatar monogram devices used by the admin and entity-config lists.
 *
 * `monogram` and `initials` are kept separate rather than folded into one function
 * with a flag because they differ deliberately in the single-word case: an
 * organisation called "Globex" reads better as GL, while a person called "Cher"
 * reads as C — padding a person's initials out to two letters looks like a typo.
 */

/** Initials of the first two words, else the first two characters. For org and team names. */
export function monogram(name: string): string {
    const words = name.trim().split(/\s+/)
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase()
    return name.slice(0, 2).toUpperCase()
}

/** Up to two initials, one per word. For people's names. */
export function initials(name: string): string {
    return name
        .split(' ')
        .slice(0, 2)
        .map((w) => w[0])
        .join('')
        .toUpperCase()
}
